import type {ICreateSuggestionsCacheOptions, ISuggestionsCache} from "../types/ISuggestionsCache";

interface ICacheEntry<T> {
    value: T;
    expiresAt: number;
}

/**
 * LRU cache with a TTL for suggestion responses. A `Map` keeps insertion order, so re-inserting on read moves an
 * entry to the most recently used end and the first key is always the eviction candidate.
 */
export const createSuggestionsCache = <T>(options: ICreateSuggestionsCacheOptions = {}): ISuggestionsCache<T> => {
    const {max = 50, ttlMs = 300_000} = options;
    const entries = new Map<string, ICacheEntry<T>>();

    const readEntry = (key: string): ICacheEntry<T> | undefined => {
        const entry = entries.get(key);

        if (entry && entry.expiresAt <= Date.now()) {
            entries.delete(key);
            return undefined;
        }

        return entry;
    };

    return {
        get: (key) => {
            const entry = readEntry(key);

            if (!entry) {
                return undefined;
            }

            entries.delete(key);
            entries.set(key, entry);

            return entry.value;
        },
        has: (key) => readEntry(key) !== undefined,
        set: (key, value) => {
            entries.delete(key);
            entries.set(key, {value, expiresAt: Date.now() + ttlMs});

            while (entries.size > max) {
                const oldestKey = entries.keys().next().value;
                if (oldestKey === undefined) {
                    break;
                }
                entries.delete(oldestKey);
            }
        },
        delete: (key) => {
            entries.delete(key);
        },
        clear: () => {
            entries.clear();
        },
        get size() {
            return entries.size;
        }
    };
};
import type {ICreateSuggestionsCacheOptions, ISuggestionsCache} from "../types/ISuggestionsCache";

interface ICacheEntry<T> {
    value: T;
    expiresAt: number;
}

/**
 * LRU cache with a TTL for suggestion responses. A `Map` keeps insertion order, so re-inserting on read moves an
 * entry to the most recently used end and the first key is always the eviction candidate.
 */
export const createSuggestionsCache = <T>(options: ICreateSuggestionsCacheOptions = {}): ISuggestionsCache<T> => {
    const {max = 50, ttlMs = 300_000} = options;
    const entries = new Map<string, ICacheEntry<T>>();

    const readEntry = (key: string): ICacheEntry<T> | undefined => {
        const entry = entries.get(key);

        if (entry && entry.expiresAt <= Date.now()) {
            entries.delete(key);
            return undefined;
        }

        return entry;
    };

    return {
        get: (key) => {
            const entry = readEntry(key);

            if (!entry) {
                return undefined;
            }

            entries.delete(key);
            entries.set(key, entry);

            return entry.value;
        },
        has: (key) => readEntry(key) !== undefined,
        set: (key, value) => {
            entries.delete(key);
            entries.set(key, {value, expiresAt: Date.now() + ttlMs});

            while (entries.size > max) {
                const oldestKey = entries.keys().next().value;
                if (oldestKey === undefined) {
                    break;
                }
                entries.delete(oldestKey);
            }
        },
        delete: (key) => {
            entries.delete(key);
        },
        clear: () => {
            entries.clear();
        },
        get size() {
            return entries.size;
        }
    };
};
